<template>
  <div class="welfare-goods">
    <div class="wall">
      <div class="wall-head">福利品</div>
      <welfare-goods-search class="media-body"  @on-search="handleSearch"/>
    </div>

    <div class="wall mt-20">
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column prop="date" label="福利品" width="180"></el-table-column>
        <el-table-column prop="name" label="库存" width="180"></el-table-column>
        <el-table-column prop="address" label="销量"></el-table-column>
        <el-table-column prop="address" label="售价"></el-table-column>
        <el-table-column prop="address" label="状态"></el-table-column>
        <el-table-column prop="address" label="操作"></el-table-column>
      </el-table>


      <div class="flex-center-center mt-20"> 
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="totalItems"
          @current-change="handlePageChage">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import WelfareGoodsSearch from './components/WelfareGoodsSearch'

export default {
  components: {
    WelfareGoodsSearch
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      totalItems: 0,
      tableData: []
    }
  },
  methods: {
    handleSearch(form) {
      console.log(form)
    },
    // 切换页码
    handlePageChage(v) {
      this.currentPage = v
    },
  }
}
</script>

<style lang="scss" scoped>
</style>